export const SCREEN_BREAKPOINTS = {
  PHONE: '599px',
  TABLET_PORTRAIT: '600px',
  TABLET_LANDSCAPE: '900px',
  DESKTOP: '1200px',
  BIG_DESKTOP: '1800px'
};

export const MEDIA_QUERIES = {
  PHONE: `@media (max-width: ${SCREEN_BREAKPOINTS.PHONE})`,
  TABLET_PORTRAIT: `@media (min-width: ${SCREEN_BREAKPOINTS.TABLET_PORTRAIT})`,
  TABLET_LANDSCAPE: `@media (min-width: ${SCREEN_BREAKPOINTS.TABLET_LANDSCAPE})`,
  DESKTOP: `@media (min-width: ${SCREEN_BREAKPOINTS.DESKTOP})`,
  BIG_DESKTOP: `@media (min-width: ${SCREEN_BREAKPOINTS.BIG_DESKTOP})`
};
